import apiClient from './apiClient';
import { API_ENDPOINTS } from '../config/api';

export interface SupportTicketCreate {
  title: string;
  description?: string;
}

export interface SupportTicket {
  id: string;
  ticket_number: string;
  title: string;
  description?: string;
  priority: string;
  category: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export interface SupportTicketsResponse {
  items: SupportTicket[];
  total: number;
  page: number;
  page_size: number;
}

export interface TicketComment {
  id: string;
  content: string;
  author_name: string;
  author_email: string | null;
  author_type: string;
  is_internal: boolean;
  created_at: string;
}

async function createTicket(data: SupportTicketCreate): Promise<SupportTicket> {
  const response = await apiClient.post(API_ENDPOINTS.SUPPORT_TICKETS, data);
  return response.data;
}

async function uploadAttachment(ticketNumber: string, file: File): Promise<any> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiClient.post(
    `${API_ENDPOINTS.SUPPORT_TICKETS}/${ticketNumber}/attachments`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return response.data;
}

async function listMyTickets(page = 1): Promise<SupportTicketsResponse> {
  const response = await apiClient.get(API_ENDPOINTS.SUPPORT_TICKETS, {
    params: { page },
  });
  return response.data;
}

async function getTicket(ticketNumber: string): Promise<SupportTicket> {
  const response = await apiClient.get(`${API_ENDPOINTS.SUPPORT_TICKETS}/${ticketNumber}`, { withCredentials: true });
  return response.data;
}

async function getTicketComments(ticketNumber: string): Promise<TicketComment[]> {
  const response = await apiClient.get(`${API_ENDPOINTS.SUPPORT_TICKETS}/${ticketNumber}/comments`, { withCredentials: true });
  return response.data;
}

async function addComment(ticketNumber: string, content: string): Promise<TicketComment> {
  const response = await apiClient.post(
    `${API_ENDPOINTS.SUPPORT_TICKETS}/${ticketNumber}/comments`,
    { content, author_type: 'reporter' },
    { withCredentials: true }
  );
  return response.data;
}

const supportService = {
  createTicket,
  uploadAttachment,
  listMyTickets,
  getTicket,
  getTicketComments,
  addComment,
};

export default supportService;
